const LocationHistoryReducer = (state = { history: [] }, action) => {
  switch(action.type) {
    case  '@@router/LOCATION_CHANGE':
      let history = [];
      history[1] = `${action.payload.pathname}${action.payload.search ? action.payload.search : ''}`;
      if(typeof state.history[1] !== 'undefined') {
        history[0] = state.history[1];
      } else {
        history[0] = "";
      }
      return {
        history
      };
    default:
      return state;
  }
};

export default LocationHistoryReducer;



// WEBPACK FOOTER //
// ./src/reducers/LocationHistoryReducer.js